import { ReactNode, useState } from 'react'
import { Card, Icon, Text } from '@/componentsV1/BaseComponents'
import { Image } from 'semantic-ui-react'
import { faMinus, faPlus } from '@fortawesome/pro-solid-svg-icons'
const SideBarEntityCard = ({
  title,
  subtitle,
  image,
  description,
}: {
  title: string
  subtitle: string
  image: string
  description: ReactNode
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Card
      type="subsection"
      backgroundColor="stone40"
      onClick={() => setIsExpanded(!isExpanded)}
      style={{ cursor: 'pointer', display: 'block', marginTop: 20 }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ flex: 4 }}>
          <Image src={image} style={{ width: 80, height: 80 }} />
        </div>

        <div style={{ flex: 10 }}>
          <Text as="h2">{title}</Text>
          <Text as="bodyXs">{subtitle}</Text>
        </div>

        <div style={{ flex: 2 }}>
          <Icon icon={isExpanded ? faMinus : faPlus} color="blue" />
        </div>
      </div>

      {isExpanded && (
        <Card type="subsection" backgroundColor="natural">
          {description}
        </Card>
      )}
    </Card>
  )
}

export default SideBarEntityCard
